import React from 'react';

function TableRowPlaceholder() {
  return (
    <tr>
      <td />
    </tr>
  );
}

export default TableRowPlaceholder;
